const ENDPOINT = 'GETreleaseDetails';
var YES_NO;
(function (YES_NO) {
    YES_NO["Yes"] = "yes";
    YES_NO["No"] = "no";
})(YES_NO || (YES_NO = {}));
var RELEASE_TYPES;
(function (RELEASE_TYPES) {
    RELEASE_TYPES["Song"] = "song";
    RELEASE_TYPES["Single"] = "single";
    RELEASE_TYPES["Single_Episode"] = "single_episode";
    RELEASE_TYPES["Episode"] = "episode";
    RELEASE_TYPES["Show"] = "show";
    RELEASE_TYPES["Album"] = "album";
    RELEASE_TYPES["ALL"] = "all"; // all types used in library
})(RELEASE_TYPES || (RELEASE_TYPES = {}));
var AVAILABLE_ACTIONS;
(function (AVAILABLE_ACTIONS) {
    AVAILABLE_ACTIONS["EDIT"] = "edit-release";
    AVAILABLE_ACTIONS["ADD_VIDEO"] = "add-video";
    AVAILABLE_ACTIONS["VIEW_ANALYTICS"] = "view-analytics";
    AVAILABLE_ACTIONS["TAKEDOWN"] = "takedown-release";
    AVAILABLE_ACTIONS["DELETE"] = "delete-release";
    AVAILABLE_ACTIONS["SHARE"] = "share-release";
    AVAILABLE_ACTIONS["MANAGE_RSS"] = "manage-rss";
    AVAILABLE_ACTIONS["EDIT_RELEASE_DIALOG"] = "edit-release-dialog";
    AVAILABLE_ACTIONS["EDIT_RELEASE_PAGE"] = "edit-release-page";
})(AVAILABLE_ACTIONS || (AVAILABLE_ACTIONS = {}));
var RELEASE_STATUSES;
(function (RELEASE_STATUSES) {
    RELEASE_STATUSES[RELEASE_STATUSES["DELETED"] = -999] = "DELETED";
    RELEASE_STATUSES[RELEASE_STATUSES["DELETED_DRAFT"] = -20] = "DELETED_DRAFT";
    RELEASE_STATUSES[RELEASE_STATUSES["NOT_LIVE"] = -1] = "NOT_LIVE";
    RELEASE_STATUSES[RELEASE_STATUSES["PENDING_RELEASE"] = 0] = "PENDING_RELEASE";
    RELEASE_STATUSES[RELEASE_STATUSES["LIVE"] = 1] = "LIVE";
    RELEASE_STATUSES[RELEASE_STATUSES["BLOCKED"] = 8] = "BLOCKED";
    RELEASE_STATUSES[RELEASE_STATUSES["PENDING_APPROVAL"] = 9] = "PENDING_APPROVAL";
    RELEASE_STATUSES[RELEASE_STATUSES["TAKENDOWN"] = 11] = "TAKENDOWN";
    RELEASE_STATUSES[RELEASE_STATUSES["MERGED"] = 12] = "MERGED";
    RELEASE_STATUSES[RELEASE_STATUSES["HEBREW_TAKENDOWN"] = 13] = "HEBREW_TAKENDOWN";
    RELEASE_STATUSES[RELEASE_STATUSES["ARTIST_TAKEN_DOWN"] = 14] = "ARTIST_TAKEN_DOWN";
    RELEASE_STATUSES[RELEASE_STATUSES["ADMIN_TAKENDOWN"] = 15] = "ADMIN_TAKENDOWN";
    RELEASE_STATUSES[RELEASE_STATUSES["BLOCKED_LABEL_TAKENDOWN"] = 16] = "BLOCKED_LABEL_TAKENDOWN";
    RELEASE_STATUSES[RELEASE_STATUSES["REJECTED"] = 17] = "REJECTED";
    RELEASE_STATUSES[RELEASE_STATUSES["AUTO_REJECTED"] = 18] = "AUTO_REJECTED";
    RELEASE_STATUSES[RELEASE_STATUSES["GOOSE_TAKENDOWN"] = 19] = "GOOSE_TAKENDOWN";
    RELEASE_STATUSES[RELEASE_STATUSES["DRAFT"] = 20] = "DRAFT";
    RELEASE_STATUSES[RELEASE_STATUSES["AWAL_TAKENDOWN"] = 24] = "AWAL_TAKENDOWN";
    RELEASE_STATUSES[RELEASE_STATUSES["SONY_TAKENDOWN"] = 33] = "SONY_TAKENDOWN";
    RELEASE_STATUSES[RELEASE_STATUSES["PROCESSING"] = 69] = "PROCESSING";
    RELEASE_STATUSES[RELEASE_STATUSES["FAILED_PROCESSING"] = 70] = "FAILED_PROCESSING";
    RELEASE_STATUSES[RELEASE_STATUSES["BLOCKED_88"] = 88] = "BLOCKED_88";
    RELEASE_STATUSES[RELEASE_STATUSES["REJECTED_171"] = 171] = "REJECTED_171";
    RELEASE_STATUSES[RELEASE_STATUSES["AUDIO_NOT_FOUND"] = 404] = "AUDIO_NOT_FOUND";
})(RELEASE_STATUSES || (RELEASE_STATUSES = {}));
var OLD_RELEASE_ITEM_KEYS;
(function (OLD_RELEASE_ITEM_KEYS) {
    OLD_RELEASE_ITEM_KEYS["songid"] = "songid";
    OLD_RELEASE_ITEM_KEYS["coverurl"] = "coverurl";
    OLD_RELEASE_ITEM_KEYS["songname"] = "songname";
    OLD_RELEASE_ITEM_KEYS["songnamear"] = "songnamear";
    OLD_RELEASE_ITEM_KEYS["albumname"] = "albumname";
    OLD_RELEASE_ITEM_KEYS["albumnamear"] = "albumnamear";
    OLD_RELEASE_ITEM_KEYS["description"] = "description";
    OLD_RELEASE_ITEM_KEYS["descriptionar"] = "descriptionar";
    OLD_RELEASE_ITEM_KEYS["genre"] = "genre";
    OLD_RELEASE_ITEM_KEYS["isrc"] = "isrc";
    OLD_RELEASE_ITEM_KEYS["upc"] = "upc";
    OLD_RELEASE_ITEM_KEYS["releasedate"] = "releasedate";
    OLD_RELEASE_ITEM_KEYS["releasetime"] = "releasetime";
    OLD_RELEASE_ITEM_KEYS["explicit"] = "explicit";
    OLD_RELEASE_ITEM_KEYS["lyrics"] = "lyrics";
    OLD_RELEASE_ITEM_KEYS["audiourl"] = "audiourl";
    OLD_RELEASE_ITEM_KEYS["languageid"] = "languageid";
    OLD_RELEASE_ITEM_KEYS["stage"] = "stage";
    OLD_RELEASE_ITEM_KEYS["albumid"] = "albumid";
    OLD_RELEASE_ITEM_KEYS["artistid"] = "artistid";
    OLD_RELEASE_ITEM_KEYS["artists"] = "artists";
    OLD_RELEASE_ITEM_KEYS["featuringartists"] = "featuringartists";
    OLD_RELEASE_ITEM_KEYS["albumtype"] = "albumtype";
    OLD_RELEASE_ITEM_KEYS["audiobucket"] = "audiobucket";
    OLD_RELEASE_ITEM_KEYS["audiokey"] = "audiokey";
    OLD_RELEASE_ITEM_KEYS["coverbucket"] = "coverbucket";
    OLD_RELEASE_ITEM_KEYS["coverkey"] = "coverkey";
    OLD_RELEASE_ITEM_KEYS["category"] = "category";
    OLD_RELEASE_ITEM_KEYS["songs"] = "songs";
    OLD_RELEASE_ITEM_KEYS["addedon"] = "addedon";
    OLD_RELEASE_ITEM_KEYS["bucket"] = "bucket";
    OLD_RELEASE_ITEM_KEYS["filename"] = "filename";
    OLD_RELEASE_ITEM_KEYS["filesize"] = "filesize";
    OLD_RELEASE_ITEM_KEYS["status"] = "status";
    OLD_RELEASE_ITEM_KEYS["hasvideo"] = "hasvideo";
    OLD_RELEASE_ITEM_KEYS["actions"] = "actions";
    OLD_RELEASE_ITEM_KEYS["releasetype"] = "releasetype";
    OLD_RELEASE_ITEM_KEYS["ispodcast"] = "ispodcast";
})(OLD_RELEASE_ITEM_KEYS || (OLD_RELEASE_ITEM_KEYS = {}));
function getReleaseDetails(gateway, params = {}) {
    return gateway.get(getReleaseDetails.endpoint, params);
}
getReleaseDetails.endpoint = ENDPOINT;

export { AVAILABLE_ACTIONS, OLD_RELEASE_ITEM_KEYS, RELEASE_STATUSES, RELEASE_TYPES, YES_NO, getReleaseDetails as default };
//# sourceMappingURL=getreleasedetails.js.map
